<template>
  <div class="pub-page">
    <div class="pub-header">
       <text class="title">{{$route.meta.title}}</text>
      <text class="title-secondary">( 请先完善参赛队信息，然后再填写其他信息 )</text>
    </div>
    <div class="pub-center">
      <div class="bg-white d-flex align-items-center flex-column py-4">
        <el-form v-loading="infoLoading" :model="form" size="large" label-width="auto" style="width: 100%;max-width: 600px" ref="ruleFormRef"
                  hide-required-asterisk :rules="rules">
          <el-form-item label="所属大学：" >
            <div class="d-flex align-items-center justify-content-between w-100 ">
              <el-input :value="userInfo.University?userInfo.University.Name?userInfo.University.Name:'未知':'未知'" class="me-2" @click="showSchool" disabled/>
            </div>
          </el-form-item>
          <el-form-item label="参赛队名：" prop="Name" >
            <div class="d-flex align-items-center justify-content-between w-100 ">
              <el-input v-model="form.Name" class="me-2"  placeholder="队名中不允许出现学校或单位的信息，例如“交大”" />
              <el-button :loading="checkLoading" v-if="form.Name && checkedName.name==form.Name && checkedName.canUser" type="success" class="flex-shrink-0" style="width: 100px;height: 38px" plain @click="checkIfCanUse" :disabled="!form.Name">队名可用</el-button>
              <el-button :loading="checkLoading" v-else-if="form.Name && checkedName.name==form.Name && !checkedName.canUser" type="danger" class="flex-shrink-0" style="width: 100px;height: 38px" plain @click="checkIfCanUse" :disabled="!form.Name">队名不可用</el-button>
              <el-button :loading="checkLoading" v-else type="primary" class="flex-shrink-0" style="width: 100px;height: 38px" plain @click="checkIfCanUse" :disabled="!form.Name">检测可用性</el-button>
            </div>
            <div class="input-des">
              队名可使用中英文，名称长度为4-30个字符，一个中文字等于2个字符。
              禁止使用特殊字符，队名中不允许出现学校或单位信息，例如“交大”
            </div>
          </el-form-item>
          <el-form-item label="参赛组别：" prop="Level">
            <el-select
                v-model="form.Level"
                placeholder="请选择"
                clearable
            >
              <el-option v-for="op in LEVELS" :label="op.Name" :value="op.ID" :key="op.ID"/>
            </el-select>
          </el-form-item>
          <el-form-item label="联系人姓名：" prop="Contact" >
            <el-input v-model="form.Contact"  placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="联系人手机号：" >
            <el-input :value="userInfo.Phone" disabled  placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="联系人邮箱：" prop="Email">
            <el-input v-model="form.Email"  placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="联系地址：" prop="Address">
            <el-input v-model="form.Address"  placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="邮政编码：" prop="PostalCode">
            <el-input v-model="form.PostalCode"  placeholder="请输入"/>
          </el-form-item>
          <div class="w-100 px-3 d-flex align-items-center justify-content-center flex-column mt-4">
            <el-button type="primary" class="btn-save"
                       v-loading="loading"
                       @click="save"
            >保存
            </el-button>
          </div>
        </el-form>
      </div>

    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {LEVELS} from "@/utils/commonSetting"
import {checkTeamName, updateTeam} from "@/api/student";
import {validateForm} from "@/utils/formValidate";
import {ElMessage} from "element-plus";
import {useStore} from "vuex";
const store = useStore()
const loading = ref(false)
const userInfo = ref({})
const infoLoading = ref(true)
const checkedName = ref({name:"",canUser:false}) // 记录检测过的名字
const checkLoading = ref(false)
const ruleFormRef = ref()

const form = reactive({
  Name: "", // 队名
  Level: null, // 组别
  Email: null, // 邮箱
  Contact: null, // 姓名
  Address: null, // 联系地址
  PostalCode: null, // 邮编
})
// 验证
const validateName = (rule, value, callback)=>{
  try {
    if (!value || !value.trim()) {
      return callback(new Error('请输入参赛队名'))
    }
    const name = value + "" // 转字符串
    const regex = /^(?!\s*$)[\u4e00-\u9fa5a-zA-Z0-9\s]+$/;
    if (!regex.test(name)) {
      // return false; // 包含特殊字符
      return callback(new Error('参赛队名不能包含特殊字符'))
    }

    // 计算长度
    let length = 0;
    for (let char of name) {
      if (/[\u4e00-\u9fa5]/.test(char)) { // 判断是否为中文字符
        length += 2;
      } else {
        length += 1;
      }
    }
    // 检查长度是否在 4-30 之间
    // return length >= 4 && length <= 30;
    if(length >= 4 && length <= 30){
      return callback()
    }else{
      return callback(new Error('队名长度不符合要求'))
    }
  }catch (e){
    return callback(new Error('队名不符合要求'))
  }


}
const rules = ({
  Name: [
    {required: true, message: '请输入队名', trigger: ['change','blur']},
    {validator: validateName, trigger: ['change','blur']}
  ],
  Level: [{required: true, message: '请选择组别', trigger: ['change','blur']}],
  Contact: [
    {required: true, message: '联系人姓名不能为空', trigger: ['change','blur']},
  ],
  Email: [
    {required: true, message: '请输入邮箱', trigger: [ 'change','blur']},
    {pattern: /^[a-zA-Z0-9_.]+@[a-zA-Z0-9-]+[.a-zA-Z]+$/, message: '请输入正确的邮箱', trigger: ['change','blur']}
  ],
  Address: [{required: true, message: '联系地址不能为空', trigger: ['change','blur']}],
  PostalCode: [{required: true, message: '邮编不能为空', trigger: ['change','blur']}],
})
onMounted( ()=>{
  getUserInfo() // 获取用户信息

})

const getUserInfo = async  ()=>{
  infoLoading.value = true
  await store.dispatch("loginModel/getUserInfo") //获取用户信息
  infoLoading.value = false
  const u = store.getters["loginModel/getUserInfo"] || {}
  checkedName.value = {name:"",canUser:false}
  userInfo.value = u
  form.Contact = u.Contact
  form.Email = u.Email
  form.Name = u.Name
  form.Level = u.Level==0?"":u.Level
  form.PostalCode = u.PostalCode
  form.Address = u.Address
}
//检测可用性
const checkIfCanUse =async ()=>{
  if(userInfo.value.Name && userInfo.value.Name === form.Name){
    return ElMessage.warning("这是您当前的队名")
  }
  checkLoading.value = true
  const res = await checkTeamName({name:form.Name})
  checkLoading.value = false
  if(res.err_code==0){
    checkedName.value = {name:form.Name,canUser: true}
  }else{
    checkedName.value = {name:form.Name,canUser: false}
  }
}
const save = async ()=>{
  const isValid = await validateForm(ruleFormRef.value)
  if (!isValid) {
    return
  }
  loading.value = true
  const res = await  updateTeam(form)
  loading.value = false
  if (res.err_code === 0) {
    ElMessage.success("信息更新成功")
    getUserInfo() // 更新信息
  } else {
    ElMessage.warning(res.err_msg || "更新失败")
  }
}

</script>

<style scoped lang="scss">
.code {
  width: 110px;
  height: 40px;
  overflow: hidden;

  .code-img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}
.btn-save {
  width: 200px;
  height: 40px;
}
.input-des{
  text-align: left;
  line-height: 20px;
  margin-top: 10px;
  color: #989797;
}

</style>
